package fr.manyverse.app.presentation.screens

import androidx.compose.foundation.layout.padding
import androidx.compose.material.icons.Icons
import androidx.compose.material.icons.automirrored.filled.ArrowBack
import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.Icon
import androidx.compose.material3.IconButton
import androidx.compose.material3.Scaffold
import androidx.compose.material3.Text
import androidx.compose.material3.TopAppBar
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.ui.Modifier
import androidx.lifecycle.compose.collectAsStateWithLifecycle
import fr.manyverse.app.presentation.components.UniverseEditForm
import fr.manyverse.app.presentation.state.AsyncUiState
import fr.manyverse.app.presentation.viewmodel.UniversesViewModel
import manyverse.shared.generated.resources.Res
import manyverse.shared.generated.resources.back
import manyverse.shared.generated.resources.create_universe
import manyverse.shared.generated.resources.edit_universe
import org.jetbrains.compose.resources.stringResource
import org.koin.compose.viewmodel.koinViewModel

@OptIn(ExperimentalMaterial3Api::class)
@Composable
fun UniverseEditScreen(
    userId: String,
    editingId: String?,
    onNavigateBack: () -> Unit,
    viewModel: UniversesViewModel = koinViewModel()
) {
    val listState by viewModel.listState.collectAsStateWithLifecycle()

    LaunchedEffect(editingId, userId) {
        if (editingId != null && listState !is AsyncUiState.Success) {
            viewModel.loadUniverses(userId)
        }
    }

    val initialUniverse = if (editingId != null && listState is AsyncUiState.Success) {
        (listState as AsyncUiState.Success).data.firstOrNull { it.id == editingId }
    } else null

    val title = stringResource(
        if (editingId == null) Res.string.create_universe else Res.string.edit_universe
    )

    Scaffold(
        topBar = {
            TopAppBar(
                title = { Text(title) },
                navigationIcon = {
                    IconButton(onClick = onNavigateBack) {
                        Icon(
                            Icons.AutoMirrored.Filled.ArrowBack,
                            contentDescription = stringResource(Res.string.back)
                        )
                    }
                }
            )
        }
    ) { padding ->
        UniverseEditForm(
            userId = userId,
            editingId = editingId,
            initialUniverse = initialUniverse,
            onSaved = onNavigateBack,
            onCancel = onNavigateBack,
            modifier = Modifier.padding(padding)
        )
    }
}
